const normalize = (value: string | undefined): string => value?.trim() ?? '';

const requiredKeys = [
  'API_BASE_URL',
  'API_KEY',
  'SUPABASE_URL',
  'SUPABASE_ANON_KEY',
  'GOOGLE_MAPS_API_KEY',
  'GOOGLE_CLIENT_ID_WEB',
  'AMPLITUDE_API_KEY',
  'ENV',
] as const;

const envValues = {
  API_BASE_URL: normalize(import.meta.env.API_BASE_URL),
  API_KEY: normalize(import.meta.env.API_KEY),
  SUPABASE_URL: normalize(import.meta.env.SUPABASE_URL),
  SUPABASE_ANON_KEY: normalize(import.meta.env.SUPABASE_ANON_KEY),
  GOOGLE_MAPS_API_KEY: normalize(import.meta.env.GOOGLE_MAPS_API_KEY),
  GOOGLE_CLIENT_ID_WEB: normalize(import.meta.env.GOOGLE_CLIENT_ID_WEB),
  AMPLITUDE_API_KEY: normalize(import.meta.env.AMPLITUDE_API_KEY),
  ENV: normalize(import.meta.env.ENV),
} as const;

export const getMissingStartupEnv = (): string[] =>
  requiredKeys.filter((key) => envValues[key].length === 0);

export const validateStartupEnv = (): void => {
  const missing = getMissingStartupEnv();
  if (missing.length > 0) {
    throw new Error(
      `[env] Missing required environment variables: ${missing.join(', ')}`,
    );
  }
};

export const env = {
  apiBaseUrl: envValues.API_BASE_URL,
  apiKey: envValues.API_KEY,
  googleMapsApiKey: envValues.GOOGLE_MAPS_API_KEY,
  googleClientIdWeb: envValues.GOOGLE_CLIENT_ID_WEB,
  supabaseUrl: envValues.SUPABASE_URL,
  supabaseAnonKey: envValues.SUPABASE_ANON_KEY,
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
  amplitudeApiKey: envValues.AMPLITUDE_API_KEY,
  environment: envValues.ENV,
} as const;

export type Env = typeof env;
